export default __webpack_public_path__ + "static/media/NMAH.AC.0433_ref8235.ae5437e1.jpg";